import { render, staticRenderFns } from "./PhotoWrapper.vue?vue&type=template&id=f7436bd8&scoped=true&"
import script from "./PhotoWrapper.vue?vue&type=script&lang=js&"
export * from "./PhotoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PhotoWrapper.vue?vue&type=style&index=0&id=f7436bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7436bd8",
  null
  
)

export default component.exports